import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatIconModule } from '@angular/material/icon';
import { IconColor } from './types/icon-color.types';
import { TranslationService } from '../../../core/services/translate.service';


@Component({
  selector: 'berry-icon',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './icon.component.html',
  styleUrls: ['./../typo/typo.component.scss', './icon.component.scss']
})
export class IconComponent implements OnChanges{
  listOfIconsToBeRotated = ['arrow_forward','arrow_right_alt','send','arrow_left','keyboard_arrow_right','keyboard_arrow_left','chevron_right','chevron_left','arrow_back_ios_new',]
  @Input() isPointer : boolean = false
  @Input() isOutlined: boolean = false;
  @Input() name: string = 'home';
  @Input() color: IconColor = 'primary';
  @Input() customClass: string = '';
  @Input() customColor !: string ;
  @Input() size: number = 24;
  @Input() opticalSize: number = 24;
  @Input() weight: 100 | 200 | 300 | 400 | 500 | 600 | 700 | number = 400;
  @Input("grade") _grade: "low" | "high" | "default" | string = "default";
  className!: string; 
  @Input({ alias: 'data-automation-id' }) dataAutomationId !: string;
  
  constructor(private translate: TranslationService) { }
  ngOnChanges(changes: SimpleChanges): void {
    this.className = `icon-${this.customColor ? '' : this.color} ${this.rotate} `;
  }
  public get fontVariationSettings(): string {
    return `"FILL" ${+!this.isOutlined}, "wght" ${this.weight}, "GRAD" ${this.grade}, "opsz" ${this.opticalSize}`;
    }

  public get grade(): number {
    switch (this._grade) {
      case "low":
        return -25;
      case "high":
        return 200;
      default:
        return 0;
    }
  }

  public get rotate(): string {
    if ((this.listOfIconsToBeRotated.includes(this.name) && this.translate.currentLang == "en")) {
      return 'rotate';

    }
    return '';
  }

}
